export const accessLinkVirtualFields = [
  {
    field: {
      value: "virtualMetaField",
      label: "Content",
      metafieldType: "file",
      index: 0,
      disabled: true,
    },
    mode: "write",
    required: true,
    wsMetaFieldDescription: "",
  },
  {
    field: {
      value: "virtualMetaField",
      label: "Caption",
      metafieldType: "text",
      index: 0,
      disabled: true,
    },
    mode: "write",
    required: true,
    wsMetaFieldDescription: "",
  },
];

export enum FormTabs {
  General = "general",
  Fields = "fields",
}
